export default "__VITE_ASSET__Bxpfqli9__"